import React from "react";
import { createUseStyles } from "react-jss";
import clsx from "clsx";
var useStyles = createUseStyles({
    tooltip: {
        position: "relative",
        display: "inline-block",
        borderBottom: "1px dotted black",
        "&:hover $tooltipText": {
            visibility: "visible"
        }
    },
    tooltipText: {
        visibility: "hidden",
        backgroundColor: "black",
        color: "#fff",
        textAlign: "center",
        borderRadius: 6,
        padding: [5, 8],
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        fontSize: 14,
        zIndex: 1,
        whiteSpace: "nowrap",
        "&:after": {
            content: '""',
            position: "absolute",
            borderStyle: "solid",
            borderWidth: 5,
        },
        "&.down": {
            transform: "translateX(-50%)",
            bottom: "150%",
            left: "50%",
            "&:after": {
                borderColor: "black transparent transparent transparent",
                top: "100%",
                left: "50%",
                marginLeft: -5,
            }
        },
        "&.up": {
            transform: "translateX(-50%)",
            top: "150%",
            left: "50%",
            "&:after": {
                borderColor: "transparent transparent black transparent",
                bottom: "100%",
                left: "50%",
                marginLeft: -5,
            },
        },
        "&.right": {
            top: -5,
            left: -8,
            transform: "translateX(-100%)",
            "&:after": {
                borderColor: "transparent transparent transparent black",
                top: "50%",
                left: "100%",
                marginTop: -5,
            },
        },
        "&.left": {
            top: -5,
            right: -8,
            transform: "translateX(100%)",
            "&:after": {
                borderColor: "transparent black transparent transparent",
                top: "50%",
                right: "100%",
                marginTop: -5,
            },
        }
    },
});
export var Pointing;
(function (Pointing) {
    Pointing["Up"] = "up";
    Pointing["Down"] = "down";
    Pointing["Left"] = "left";
    Pointing["Right"] = "right";
})(Pointing || (Pointing = {}));
var Tooltip = function (_a) {
    var children = _a.children, tip = _a.tip, pointing = _a.pointing;
    var classes = useStyles();
    var tooltipTextClass = clsx(classes.tooltipText, pointing);
    return (React.createElement("div", { className: classes.tooltip },
        children,
        React.createElement("span", { className: tooltipTextClass }, tip)));
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map